<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h1 class="card-title mb-0">Historial de reuniones</h1>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-8">
            <dates-table :protocol="protocol"
                         :committee="committee"
                         ref="dates-table"></dates-table>
          </div>
          <div class="col-md-4">
            <form id="frm-date"
                  ref="frm-date"
                  onsubmit="return false">
              <div class="form-group">
                <label class="d-block"
                       for="date">Ingresar nueva fecha de revisión:
                  <abbr style="text-decoration: none;"
                        title="Campo obligatorio">*</abbr>
                </label>
                <input id="date"
                       v-model="date"
                       class="form-control"
                       name="date"
                       ref="date"
                       type="date">
              </div>
              <div class="form-group">
                <button :disabled="!cantAddDate"
                        class="btn btn-primary"
                        type="submit">
                  Registrar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    
    <div class="card">
      <div class="card-header">
        <h1 class="card-title mb-0">Información general</h1>
      </div>
      <div class="card-body">
        <dictum-information :protocol="protocol"
                            :committee="committee"
                            @show-comments="comments => $emit('show-comments', comments)"
                            @cancel-reviewer="userId => $emit('cancel-reviewer', userId)"></dictum-information>
      </div>
    </div>
    
    <portal to="modals">
      <ok-cancel-dialog id="accept-modal"
                        ref="accept-modal"
                        :ok-button-text="'Confirmar'"
                        content="<p>¿Esta seguro de asignar esta fecha para revisión?</p>"
                        title="Confirmar registro"
                        @ok-button-pressed="saveDate"></ok-cancel-dialog>
    </portal>
  </div>
</template>

<script>
  import 'jquery-validation'
  import DynamicTable from '../../ui/DynamicTable'
  import OkCancelDialog from '../../ui/OkCancelDialog'
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import { AlertManager } from '../../utils/AlertManager'
  import DictumInformation from './DictumsInformation'
  import DatesTable from './DatesTable'
  import 'flatpickr'
  import { Spanish } from 'flatpickr/dist/l10n/es'
  import 'flatpickr/dist/flatpickr.min.css'
  
  export default {
    name: 'GeneralInformation',
    components: {
      DictumInformation,
      DynamicTable,
      OkCancelDialog,
      DatesTable,
    },
    data() {
      return {
        date: '',
      }
    },
    props: {
      protocol: Object,
      committee: Object,
    },
    computed: {
      ...mapGetters({
        dates: 'committees/dates',
        dictums: 'committees/dictums',
      }),
      
      totalDictums() {
        return this.dictums ?
          this.dictums.filter(
            dictum => dictum.committee_id === this.committee.id
          ).length : 1
      },
      
      totalDateDictum() {
        return this.dates ? this.dates.length : 0
      },
      
      cantAddDate() {
        const totalCommitteeDictums = this.dictums.filter(
            dictum => dictum.committee_id === this.committee.id
          ).length;
        
        return (totalCommitteeDictums === 0  && this.totalDateDictum < 1)|| this.totalDateDictum <= this.totalDictums
      },
    },
    methods: {
      ...mapActions({
        saveDateDictum: 'committees/saveDateDictum',
      }),
      
      ...mapMutations({
        addDate: 'committees/ADD_DATE',
      }),
      
      async saveDate() {
        this.$refs['accept-modal'].sending = true
        
        const response = await this.saveDateDictum({
          'protocol_id': this.protocol.id,
          'committee_id': this.committee.id,
          'date': this.date,
        })
        
        AlertManager.success(response.data.data.message)
        
        this.$refs['dates-table'].load()
        
        this.date = null
        
        this.$refs['accept-modal'].sending = false
        this.$refs['accept-modal'].close()
      },
    },
    async mounted() {
      const vm = this
      
    $(this.$refs.date).flatpickr({
        disableMobile: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
        minDate: new Date(),
      })
      
      $('#frm-date').validate({
        highlight: function(element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function(element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function(label, element) {
          label.addClass('invalid-feedback')
          label.insertAfter(element)
        },
        rules: {
          date: {
            required: true,
          },
        },
        messages: {
          date: {
            required: 'Este campo es requerido.',
          },
        },
        submitHandler(form) {
          $('#accept-modal').modal('show')
        },
      })
    },
  }
</script>
